export default "__VITE_ASSET__BrYSCwjj__"